<template>
<div>
    <div class="solutions">
            <h4>解决方案</h4>
            <div class="itemlist rows">
                <div class="solution_item column" v-for="item in lists" :key="item.title">
                  <router-link :to="item.id">
                          <div class="img_box">
                      <img :src="item.img" alt="">
                </div>
                  </router-link>        
                <p>{{item.title}}</p>
            </div>
            </div>
        </div>
         <foot></foot>


</div>
     

</template>
<style>
.solutions {
  height: 10.4rem;
  background: rgba(245, 245, 245, 1);
}
.solutions h4 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  padding-top: 0.55rem;
  padding-bottom: 0.36rem;
  text-align: center;
}
.solutions .itemlist {
  width: 12rem;
  margin: 0 auto;
  flex-wrap: wrap;
}
.solution_item {
  width: 3.86rem;
  height: 2.62rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin-right: 0.1rem;
  margin-bottom: 0.3rem;
  box-shadow: 0 0.05rem 0.11rem 0 rgba(223, 224, 233, 1);
  cursor: pointer;
}
.solutions .img_box {
  width: 100%;
  height: 2.1rem;
}
.solutions p {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  padding-top: 0.18rem;
  padding-left: 0.21rem;
  cursor: pointer;
}
</style>
<script>
import footer from "../common/footer";
export default {
  data() {
    return {
      lists: [
        {
          id: "/subway",
          img: require("../assets/cases/ditie.png"),
          title: "地铁自动化监测"
        },
        {
          id:"/tunnel",
          img: require("../assets/cases/suidao.png"),
          title: "隧道自动化监测"
        },
        {
          id:"/bridge",
          img: require("../assets/cases/qiaoliang.png"),
          title: "桥梁自动化监测"
        },
        {
          id:"/dam",
          img: require("../assets/cases/daba.png"),
          title: "大坝自动化监测"
        },
        {
          id:"/side",
          img: require("../assets/cases/bianp.png"),
          title: "边坡自动化监测"
        },
        {
          id:"/pit",
          img: require("../assets/cases/jikeng.png"),
          title: "基坑自动化监测"
        },
        {
          id:"/gangue",
          img: require("../assets/cases/weik.png"),
          title: "尾矿自动化监测"
        },
        {
          id:"/relic",
          img: require("../assets/cases/wenwu.png"),
          title: "文物遗产自动化监测"
        },
        {
          id:"/damage",
          img: require("../assets/cases/dizhi.png"),
          title: "地质灾害自动化监测"
        }
      ]
    };
  },
  components: {
    foot: footer
  }
};
</script>





// WEBPACK FOOTER //
// src/homepages/solution.vue